<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs9>
        <v-text-field
          v-model="namespace"
          class="mb-4"
          :label="$t('deployment_name')"
          :rules="namespaceRules"
          required
        />
      </v-flex>
      <v-flex class="ml-2 mt-3" xs2>
        <v-btn
          color="primary"
          @click="createNamespace(namespace)"
          :disabled="!namespace || !validateNamespace(namespace)"
          :loading="pending"
          small
        >
          {{ $t('notice.create') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NetworkService from '@/services/network'

export default {
  data () {
    return {
      namespace: undefined,
      namespaceRules: [
        (n) => !!n || this.$t('error.namespace_required'),
        (n) => this.validateNamespace(n) || this.$t('error.namespace_invalid'),
        (n) => !this.namespaces.includes(n) || this.$t('error.namespace_exists')
      ],
      pending: false
    }
  },
  props: {
    namespaces: []
  },
  methods: {
    createNamespace (namespace) {
      if (!this.validateNamespace(namespace)) {
        return
      }

      this.pending = true
      NetworkService.createNamespace(namespace).finally(() => {
        this.pending = false
      })
    },
    validateNamespace (namespace) {
      return /^[a-zA-Z0-9._-]{1,32}$/.test(namespace)
    }
  }
}
</script>

<i18n>
{
  "en": {
    "deployment_name": "Deployment Name",
    "error": {
      "namespace_required": "The namespace is required.",
      "namespace_invalid": "It must be at most 32 characters long and only contain letters, numbers, dots, dashes and underscores.",
      "namespace_exists": "Namespace exists"
    },
    "notice": {
      "create": "Create"
    }
  }
}
</i18n>
